module.exports = __webpack_public_path__ + "static/media/icon-facebook.180a6ca6.svg";